import { memo } from 'react';
import styles from '../../publicationDetail.module.scss';
import { PublicationStatusBadgeProps } from '../../interfaces';

const PublicationStatusBadge = ({
  publication,
  type
}: PublicationStatusBadgeProps) => {
  // No mostrar badge para "myPublication"
  if (type === "myPublication" || !publication?.status_brief?.code) {
    return null;
  }

  const getStatusConfig = () => {
    const { code } = publication.status_brief;
    const { opportunity } = publication;

    if (code === "sold_out") {
      return {
        className: styles.soldBadge,
        text: "Vendido"
      };
    }

    if (code === "reserved") {
      return {
        className: styles.reservedBadge,
        text: "Reservado"
      };
    }

    if (opportunity === true && code !== "reserved" && code !== "sold_out") {
      return {
        className: styles.opportunityBadge,
        text: "Oportunidad"
      };
    }

    return null;
  };

  const statusConfig = getStatusConfig();
  if (!statusConfig) return null;

  return (
    <div className={styles.statusBadge}>
      <span className={statusConfig.className}>
        {statusConfig.text}
      </span>
    </div>
  );
};

export default memo(PublicationStatusBadge);
